// extracted by mini-css-extract-plugin
module.exports =  {"cardIcon":"cardIcon__jdx3a","cardRow":"cardRow__8dnBk","cardSpacer":"cardSpacer__JWT9l"};